import React, { useState } from 'react'
import Classes from './Settings.module.css'
import InfoTab from './Comp/InfoTab';
import ResetPassword from './Comp/ResetPassword';

export default function Settings() {
    const [activeTab, setactiveTab] = useState(1);

    return (
        <div className={Classes.hero}>
            <div className={Classes.header}>
                <div>
                    <h3 className={Classes.title3} >Settings</h3>
                    <h5 className={Classes.text} >Manage your account settings.</h5>
                </div>
            </div>

            <div className={Classes.navigation} >
                <button className={`${Classes.btn1} ${activeTab === 1 ? Classes.activeBtn : ''} `} onClick={() => { setactiveTab(1) }} > <h5>Profile</h5> </button>
                <button className={`${Classes.btn2}`} > <h5>Log Out</h5> </button>
            </div>

            <h3 className='mb-20' >Profile</h3>

            {activeTab === 1 && <InfoTab />}

            <h3 className='mb-20' >Reset Password</h3>

            <ResetPassword />

        </div>
    )
}
